import { render, staticRenderFns } from "./TextLine.vue?vue&type=template&id=06c6a560"
import script from "./TextLine.vue?vue&type=script&setup=true&lang=js"
export * from "./TextLine.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports